import * as Immutable from 'immutable';
import { IImageStore } from '../ImageList/_stores/ImageStore';
import DocumentStore from './../Document/_stores/DocumentStore';
import HIDStore from './../HID/_stores/HIDStore';
import LayerListStore from './../LayerList/_stores/LayerListStore';
import ModuleCreatorStore from './../ModuleCreator/_stores/ModuleCreatorStore';
import ModuleListStore from './../ModuleList/_stores/ModuleListStore';
import ToolsStore from './../Tools/_stores/ToolsStore';
import ViewerStore from './../Viewer/_stores/ViewerStore';
import WindowStore from './../Window/_stores/WindowStore';
import IntroStore from './../Intro/_stores/IntroStore';

export interface ICreateStore {
	document: DocumentStore
	hid: HIDStore
	imageList: Immutable.OrderedMap<string, IImageStore>
	layerList: LayerListStore
	moduleCreator: ModuleCreatorStore
	moduleList: ModuleListStore
	tools: ToolsStore
	viewer: ViewerStore
	window: WindowStore
	intro: IntroStore
}

const defaultStore = Immutable.Record<ICreateStore>({
	document: new DocumentStore(),
	hid: new HIDStore(),
	imageList: Immutable.OrderedMap<string, IImageStore>(),
	layerList: new LayerListStore(),
	moduleCreator: new ModuleCreatorStore(),
	moduleList: new ModuleListStore(),
	tools: new ToolsStore(),
	viewer: new ViewerStore(),
	window: new WindowStore(),
	intro: new IntroStore(),
});

export default class CreateStore extends defaultStore implements ICreateStore {}